import React from 'react';

const QuestionAndAnswer = ({ question }) => (
  <div className="flex-grow mt-2 md:mt-0">
    <div className="text-left paragraph-three text-paragraph-three-mobile md:text-paragraph-three md:text-lg">{question}</div>
  </div>
);

export default QuestionAndAnswer;
